import instance from '../utils/axios';

export interface QcQueueItem {
  id: number;
  material_code: string;
  material_type: string;
  design_no: string | null;
  garment_part: string | null;
  size: string | null;
  available_qty: number;
  quantity: number;
  uom: string;
  rate: number | null;
  source_job_work_id: number | null;
  image_url: string | null;
  created_at: string;
  qc_hold: boolean;
  qc_cleared_at: string | null;
  source_job_work: {
    id: number;
    jobWorkCode: string;
    vendor: { registered_name: string; alias: string | null };
  } | null;
}

export interface QcInspection {
  id: number;
  material_inward_id: number;
  design_no: string | null;
  garment_part: string | null;
  size: string | null;
  source_job_work_id: number | null;
  total_pieces: number;
  passed_pieces: number;
  failed_pieces: number;
  repair_pieces: number;
  notes: string | null;
  inspected_by: string | null;
  inspected_at: string;
  material_inward?: {
    id: number;
    material_code: string;
    design_no: string | null;
    garment_part: string | null;
    size: string | null;
    available_qty: number;
    uom: string;
    image_url: string | null;
  };
}

export interface InspectPayload {
  passed_pieces: number;
  failed_pieces: number;
  repair_pieces: number;
  notes?: string;
}

export const qcStationApi = {
  getQueue: async (): Promise<{ items: QcQueueItem[]; total: number }> => {
    const res = await instance.get('/qc-station/queue');
    return res.data;
  },

  getHistory: async (page = 1, limit = 25): Promise<{
    inspections: QcInspection[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  }> => {
    const res = await instance.get('/qc-station/history', { params: { page, limit } });
    return res.data;
  },

  inspect: async (materialId: number, data: InspectPayload): Promise<{
    message: string;
    inspection: QcInspection;
    material_available_qty: number;
  }> => {
    const res = await instance.post(`/qc-station/${materialId}/inspect`, data);
    return res.data;
  },
};
